import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import { Today } from "@material-ui/icons";
import moment from "moment";
import { translate as t } from "../../../../translate/localization";
import useStyles from "../../styles";
import CobeeDatePicker from "../../../../../app/components/CobeeDatePicker";

export default function RowDate({ date, setDate }) {
  const { secondColumn, datepicker } = useStyles();
  return (
    <>
      <Grid item xs={6} container alignItems="center">
        <Typography variant="body2">
          {t("request-section.payroll-substraction-start-date")}: <br />
          {t("request-section.payroll-substraction-message")}
        </Typography>
      </Grid>
      <Grid item xs={6} className={secondColumn}>
        <CobeeDatePicker
          showMonthYearPicker
          minDate={new Date(moment().add(1, "months").startOf("month"))}
          selectedDate={date}
          onChange={setDate}
          customInput={
            <div className={datepicker}>
              <Grid
                container
                justify="space-between"
                alignItems="center"
                item
                xs={12}
              >
                <Typography variant="caption">
                  {moment(date).format("MMMM YYYY")}
                </Typography>
                <Today />
              </Grid>
            </div>
          }
        />
      </Grid>
    </>
  );
}

RowDate.propTypes = {
  date: PropTypes.instanceOf(Date),
  setDate: PropTypes.func,
};

RowDate.defaultProps = {
  date: new Date(moment().add(1, "months").startOf("month")),
  setDate: () => {},
};
